module.exports = __webpack_public_path__ + "img/14.e203b251.jpg";